<template>
  <div class="sd-tool-menu-bar">
    <div class="tool-btn-box shadow">
      <div class="tool-btn-item" v-for="(item,index) in data" 
      :key="item.name" 
      :class="{'btn-item__actived':item.checked}" >
        <svg-icon :icon-class="item.icon" class="tool-btn__image" />
        <el-popover v-if="item.children && item.children.length" :ref="'popover'+index"  :close-delay="500" trigger="hover">
          <div class="btn-item-child" 
            v-for="child in item.children" 
            :key="child.name" 
            :class="{'btn-item__actived':child.checked}" 
            @click="handlePopoverClick(child,index)">
            <svg-icon :icon-class="child.icon" class="tool-btn__image" />
            <span >{{ child.label  || child.name}}</span>
          </div>
          <span slot="reference">{{ item.label || item.name}}</span>
        </el-popover>
        <span v-else @click="item.click(item)">{{ item.label || item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SdToolMenu',
  props: {
    data: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      
    };
  },
  watch:{
    data(){ 
      this.initWidth()
    }
  },
  mounted() {
    this.initWidth() 
  },

  methods: {
    handlePopoverClick(item,index){
      item.click && item.click(item)
      let popover = this.$refs['popover'+index]
      popover && Array.isArray(popover) ? popover[0]?.doClose() : popover?.doClose()
      
    },
    initWidth(){
      let width = 0
      this.data && 
      this.data.forEach(item => {
        width += item.width || 84
      })
      this.$el.style.width = width + 'px'
    },
  },
};
</script>
<style scoped>
/*
  地图菜单
  @component GyToolMenu
*/
.sd-tool-menu-bar{
  position: absolute;
  top:20px;
  right:40px;
  width:0;
  display: flex;
  transition:all 1s;
  user-select: none;
}
.tool-btn-box{
  background-color: white;
  border-radius: 10px;
  display: flex;
  padding: 10px 0;
  user-select: none;
}
.tool-btn-item{
  /* margin: 5px; */
  padding: 0 15px;
  border-right: 1px dashed #cccccc;
  cursor: pointer;
  white-space:nowrap;
  color: black;
}
.tool-btn-item:hover{
  color: #409eff;
}
.btn-item__actived{
  color:#409eff !important;
}
.tool-btn-item:last-child{
  border-right: none;
}
.tool-btn__image{
  width:16px !important;
  height: 16px !important;
  margin-right: 5px;
  padding-top:1px;
}
.btn-item-child{
  cursor: pointer;
  padding: 5px 10px;
  margin-top:5px;
  border-bottom: 1px dashed #efefef;
}
.btn-item-child:hover{
  background-color: #efefef;
}
.btn-item-child:last-child{
  border-bottom: none;
}

</style>